import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { Button } from "components/bootstrap";
import { LinkContainer, Spinner } from "components/common";
import useRunWorkflow from "aiagent/AgentWorkflows/hooks/useRunWorkflow";
import AgentWorkflowRoutes from "aiagent/Routes";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import usePermissions from "hooks/usePermissions";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
const runButtonTitle = (workflowTitle, hasConfig, aiDisabled) => {
  if (aiDisabled) {
    return i18n.t("run_workflow_button.ai_disabled", { ns: "enterprise_ai" });
  }
  return hasConfig ? i18n.t("run_workflow_button.run_title", { ns: "enterprise_ai", title: workflowTitle }) : i18n.t("run_workflow_button.setup_provider", { ns: "enterprise_ai" });
};
const RunWorkflowButton = ({ workflow, onSuccess }) => {
  const { t } = useTranslation("enterprise_ai");
  const sendTelemetry = useSendTelemetry();
  const { isPermitted } = usePermissions();
  const { mutate, isPending } = useRunWorkflow({ type: workflow.id, title: workflow.title, onSuccess });
  const {
    data: { isEnabled: aiEnabled },
    isLoading: isLoadingAIConfiguration
  } = useAIConfiguration();
  const runWorkflow = (event) => {
    event.stopPropagation();
    sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.WORKFLOW_RUN_TRIGGERED, {
      app_section: "aiagent-workflows",
      event_details: { workflow_type: workflow.id }
    });
    mutate();
  };
  if (workflow.active_run_id) {
    if (isPermitted("agent_workflow:debug")) {
      return /* @__PURE__ */ React.createElement(LinkContainer, { to: AgentWorkflowRoutes.runDetails(workflow.active_run_id) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", title: t("run_workflow_button.in_progress_view", { title: workflow.title }) }, /* @__PURE__ */ React.createElement(Spinner, { text: t("run_workflow_button.view_run"), delay: 0 })));
    }
    return /* @__PURE__ */ React.createElement(Button, { bsStyle: "warning", disabled: true, title: t("run_workflow_button.in_progress", { title: workflow.title }) }, /* @__PURE__ */ React.createElement(Spinner, { text: t("run_workflow_button.running"), delay: 0 }));
  }
  const hasConfig = !!((workflow == null ? void 0 : workflow.model) && (workflow == null ? void 0 : workflow.provider));
  const aiDisabled = !isLoadingAIConfiguration && !aiEnabled;
  const title = runButtonTitle(workflow.title, hasConfig, aiDisabled);
  return /* @__PURE__ */ React.createElement(Button, { title, bsStyle: "success", disabled: isPending || !hasConfig || aiDisabled, onClick: runWorkflow }, isPending ? t("run_workflow_button.starting") : t("run_workflow_button.run_workflow"));
};
export default RunWorkflowButton;
